import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import ApiProvider from "./contexts/ApiProvider";
import Container from "react-bootstrap/Container";
import ExplorePage from "./components/AllCasesView/ExplorePage";
import FlashProvider from "./contexts/FlashProvider";
import Header from "./components/Navigation/Header";
// import Landing from "./components/IntroPage/LandingPage";
import LoginPage from "./components/Login/LoginPage";
import Overlaps from "./components/OverlapView/Overlaps";
import PatientPage from "./components/PatientView/PatientPage";
import PostSurveyPage from "./components/PostSurvey/PostSurvey";
import PreSurveyPage from "./components/PreSurvey/PreSurvey";
import PrivateRoute from "./components/Routes/PrivateRoute";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import PublicRoute from "./components/Routes/PublicRoute";
import RegistrationPage from "./components/Login/RegistrationPage";
import SurveyModeProvider from "./contexts/SurveyModeProvider";
import UserProvider from "./contexts/UserProvider";
import { createRef } from "react";

export default function App() {
  const viewedRef = createRef();
  return (
    <Container fluid className="App">
      <BrowserRouter>
        <FlashProvider>
          <ApiProvider>
            {" "}
            <UserProvider>
              <SurveyModeProvider>
                <Header />
                <Routes>
                  <Route
                    path="/login"
                    element={
                      <PublicRoute>
                        <LoginPage />
                      </PublicRoute>
                    }
                  />
                  <Route
                    path="/register"
                    element={<RegistrationPage />}
                  />
                  <Route
                    path="*"
                    element={
                      <PrivateRoute>
                        <Routes>
                          <Route path="/prior" element={<PreSurveyPage />} />
                          {/* <Route path="/intro" element={<Landing />} /> */}
                          <Route path="/" element={<ExplorePage />} />
                          <Route
                            path="/overlap/:micro_id"
                            element={<Overlaps />}
                          />
                          <Route
                            path="/patient/:micro_id"
                            element={<PatientPage />}
                          />
                          <Route path="*" element={<Navigate to="/" />} />
                          <Route path="/final" element={<PostSurveyPage />} />
                          <Route path="/profile" element={<ProfilePage />} />
                        </Routes>
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </SurveyModeProvider>
            </UserProvider>
          </ApiProvider>
        </FlashProvider>
      </BrowserRouter>
    </Container>
  );
}
